import { ISubMenu } from 'models'
import { Link, useLocation } from 'react-router-dom'
import SubMenuStyled from './styled'


interface SubMenuProps {
  subMenu: ISubMenu[]
}
export default function SubMenu({ subMenu }: SubMenuProps) {

  const { pathname } = useLocation()

  return (
    <SubMenuStyled>
      <div className='sub-menu'>
        <ul className='select-content-dropdown'>
          {subMenu && subMenu.map((item: ISubMenu, index: number) => (
            <li
              key={index}
            >
              <Link to={item.path} className={pathname === item.path ? 'active' : ''} >
                {item.name}
              </Link>
            </li>
          ))}
          <div className='polygon'>
            <div className='rect'></div>
            <div className='triangle'>
              <div className='triangle-border'></div>
            </div>
          </div>
        </ul>
      </div>
    </SubMenuStyled>
  )
}
